import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Youtube } from 'lucide-react';
import axios from 'axios';
import { SiFacebook, SiInstagram, SiTiktok, SiWhatsapp, SiYoutube } from 'react-icons/si';


const Footer = () => {
  const [siteIcon, setSiteIcon] = useState<string | null>(null);
  type SocialLink = {
    handle: string;
    url: string;
  };
  const [socials, setSocials] = useState<{
    facebook?: { handle: string; url: string };
    youtube?: { handle: string; url: string };
    tiktok?: { handle: string; url: string };
    instagram?: { handle: string; url: string };
    twitter?: { handle: string; url: string };
    whatsapp?: { handle: string; url: string };
  }>({});
  useEffect(() => {
    const fetchSiteIcon = async () => {
      try {
        const response = await axios.get('https://api.ibadansouthanglicandiocese.org.ng/api/v1/footer_logo');
        setSiteIcon(response.data);
      } catch (error) {
        console.error('Failed to fetch site icon', error);
      }
    };

    const fetchSocialLinks = async () => {
      try {
        const res = await axios.get('https://api.ibadansouthanglicandiocese.org.ng/api/v1/social_handles');
        setSocials(res.data);
        console.log(res.data)
      } catch (err) {
        console.error('Failed to fetch social handles', err);
      }
    };

    fetchSiteIcon();
    fetchSocialLinks();
  }, []);

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Diocese Info */}
          <div className="space-y-4">
            <Link to="/" className="w-full flex items-center">
              <div className="w-full overflow-hidden flex items-center justify-center">
                {siteIcon ? (
                  <img src={siteIcon} alt="Site Icon" className="w-full h-full object-cover" />
                ) : (
                  <span className="text-white font-bold text-lg bg-purple-700 w-full h-full flex items-center justify-center">✝</span>
                )}
              </div>
            </Link>
            <p className="text-gray-300 text-sm">
              Serving the Anglican faithful in Ibadan South with dedication to spreading the Gospel
              and building God's kingdom on earth.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white">About Us</Link></li>
              <li><Link to="/bishop" className="text-gray-300 hover:text-white">Our Bishop</Link></li>
              <li><Link to="/clergy" className="text-gray-300 hover:text-white">Our Clergy</Link></li>
              <li><Link to="/archdeaconries" className="text-gray-300 hover:text-white">Archdeaconries</Link></li>
              <li><Link to="/events" className="text-gray-300 hover:text-white">Events</Link></li>
              <li><Link to="/support" className="text-gray-300 hover:text-white">Support & Donations</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><Link to="/gallery" className="text-gray-300 hover:text-white">Photo Gallery</Link></li>
              <li><Link to="/videos" className="text-gray-300 hover:text-white">Video Gallery</Link></li>
              <li><Link to="/news" className="text-gray-300 hover:text-white">News & Updates</Link></li>
              {/* <li><Link to="/sermons" className="text-gray-300 hover:text-white">Sermons</Link></li> */}
              {/* <li><Link to="/publications" className="text-gray-300 hover:text-white">Publications</Link></li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-2 text-gray-300 text-sm">
              <p>Diocese of Ibadan South</p>
              <p>Cathedral Church of St. David, Kudeti</p>
              <p>Ibadan, Oyo State, Nigeria</p>
              <p>Email: info@ibadansouthanglicandiocese.org.ng</p>
              {/* <p>Phone: +234 xxx xxxx xxx</p> */}
            </div>
            <div className="flex space-x-4 mt-4">
              {socials.facebook && (
                <Link to={socials.facebook?.url} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <SiFacebook className="h-5 w-5" />
                </Link>
              )}
              {socials.youtube && (
                <Link to={socials.youtube?.url} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <SiYoutube className="h-5 w-5" />
                </Link>
              )}
              {socials.tiktok && (
                <Link to={socials.tiktok?.url} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <SiTiktok className="h-5 w-5 size={24}" color="#fff" />
                </Link>
              )}
              {socials.instagram && (
                <Link to={socials.instagram?.url} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <SiInstagram className="h-5 w-5" />
                </Link>
              )}
              {socials.twitter && (
                <Link to={socials.twitter?.url} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <Twitter className="h-5 w-5" />
                </Link>
              )}
              {socials.whatsapp?.url && (
                <Link to={socials.whatsapp.url} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <SiWhatsapp className="h-5 w-5" />
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Diocese of Ibadan South, Anglican Communion. All rights reserved. | Website powered by <span className="font-semibold">IBSD Media Team</span>.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
